import React from 'react'
import { Row, Col, Label } from 'reactstrap'
import { Validator } from 'components/validation'
import { Input } from 'components/inputs'

export const ContactForm = ({ entity, updateEntity, disabled, localize }) => {
  return (
    <React.Fragment>
      <Row>
        <Col sm='6'>
          <Label>{localize('common.address')}</Label>
          <Validator name='address' value={entity.address} maxLength={255} disabled={disabled}>
            <Input value={entity.address} onChange={updateEntity('address')} placeholder={localize('common.address')} disabled={disabled} />
          </Validator>
        </Col>
        <Col sm='6'>
          <Label>{localize('common.address2')}</Label>
          <Validator name='address2' value={entity.address2} maxLength={255} disabled={disabled}>
            <Input value={entity.address2} onChange={updateEntity('address2')} disabled={disabled} />
          </Validator>
        </Col>
      </Row>
      <Row>
        <Col sm='6'>
          <Label>{localize('common.city')}</Label>
          <Validator name='city' value={entity.city} maxLength={120} disabled={disabled}>
            <Input value={entity.city} onChange={updateEntity('city')} placeholder={localize('common.city')} disabled={disabled} />
          </Validator>
        </Col>
        <Col sm='6'>
          <Label>{localize('common.zipCode')}</Label>
          <Validator name='zipCode' value={entity.zipCode} maxLength={25} disabled={disabled}>
            <Input value={entity.zipCode} onChange={updateEntity('zipCode')} placeholder={localize('common.zipCode')} disabled={disabled} />
          </Validator>
        </Col>
      </Row>
      <Row>
        <Col sm='6'>
          <Label>{localize('common.email')}</Label>
          <Validator name='email' value={entity.email} maxLength={255} disabled={disabled}>
            <Input value={entity.email} onChange={updateEntity('email')} placeholder={localize('common.email')} disabled={disabled} />
          </Validator>
        </Col>
        <Col sm='6'>
          <Label>{localize('common.web')}</Label>
          <Validator name='web' value={entity.web} maxLength={255} disabled={disabled}>
            <Input value={entity.web} onChange={updateEntity('web')} placeholder={localize('common.web')} disabled={disabled} />
          </Validator>
        </Col>
      </Row>
    </React.Fragment>
  )
}


